import { render, staticRenderFns } from "./AssignedTodoView.vue?vue&type=template&id=a74647d8"
import script from "./AssignedTodoView.vue?vue&type=script&lang=js"
export * from "./AssignedTodoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports